import { render, staticRenderFns } from "./DynamicTableView.vue?vue&type=template&id=0e1502b0"
import script from "./DynamicTableView.vue?vue&type=script&lang=js"
export * from "./DynamicTableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports